import React from "react";

const Header = () => {
  return (
    <div>
      <h1>Expense Tracker</h1>
      <hr></hr>
    </div>
  );
};

export default Header;
